import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import BuyNowPayLaterDetails from 'dpl/puppy_page/components/BuyNowPayLaterDetails';

/** @param {any} props */
export default function KlarnaDescription({
  className = null,
  as: Component = 'p'
}) {
  return (
    <Component className={classnames('KlarnaDescription', className)}>
      Pay over time with Klarna.{' '}
      <BuyNowPayLaterDetails className="stone-700" buttonCTA="Learn more" />
    </Component>
  );
}

KlarnaDescription.propTypes = {
  className: PropTypes.string,
  as: PropTypes.string
};
